import React from 'react';
import { styled } from "../../../stitches.config"

import img from "./assets/quote-img.png"
import icon from "./assets/quote-icon.svg"

interface AtavistTestingQuoteProps {
}

const AtavistTestingQuote: React.FC<AtavistTestingQuoteProps> = ({
    ...props
}) => {
    return (
        <StyledAtavistTestingQuote>
            <ImageWrapper>
                <img src={img} />
                <Icon></Icon>
            </ImageWrapper>
            <TextWrapper>
                <Quote><span>"</span>Jestem mamą 4 dzieci i redaktorką naczelną serwisu mama:Du. Przez mój dom przewinęły się setki zabawek i wszelkiego rodzaju produktów dla dzieci. Doskonale wiem, jak ważne dla mnie, dzieci i budżetu domowego są świadome zakupy. Pozwól, bym Ci w nich pomogła.<span>"</span></Quote>
                <Author>Marta Kabulska</Author>
            </TextWrapper>
        </StyledAtavistTestingQuote>
    );
};


const StyledAtavistTestingQuote = styled('div', {
    color: "#131212",
    maxWidth: "840px",
    margin: "0 auto 60px auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "@bp4": {
        flexDirection: "row",
        paddingTop: "66px",
        margin: "0 auto 80px auto",
    }
})

const Quote = styled('p', {
    marginTop: 0,
    "span": {
        color: "#2dcdcc",
        "@media(min-width: 400px)": {
            display: "none"
        }
    }
})

const Icon = styled('div', {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundImage: `url("${icon}")`,
    height: "50px",
    width: "62px",
    position: "absolute",
    top: "240px",
    left: "-40px",
    display: "none",
    "@media(min-width: 400px)": {
        top: "240px",
        left: "-40px",
        display: "block",
    },
    "@media(min-width: 460px)": {
        top: "240px",
        left: "-70px",
    },
    "@bp4": {
        top: "-40px",
        left: "270px",
    }
})

const Author = styled('p', {
    marginTop: "40px",
})

const TextWrapper = styled('div', {
    fontSize: "21px",
    lineHeight: "34px",
    fontStyle: "italic",
    maxWidth: "480px",
    fontFamily: "$charis",
    padding: "25px 34px 0 44px",
    "@bp4": {
        marginLeft: "66px",
        padding: 0,
    }
})

const ImageWrapper = styled('div', {
    position: "relative",
    "img": {
        width: "293px",
    }
})

export default AtavistTestingQuote
